var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('entity-select-option');
import { breakpoints, theme } from '@shapeable/theme';
import { EntityValue } from './entity-value';
import { components as Components } from 'react-select';
import { coalesce } from '../../utils/coalesce';
import { ContentNode } from './content-node';
export var EntitySelectOptionDefaultProps = {
  showDescription: false
}; // -------- Child Component Props -------->
// -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    padding: ", ";\n    flex-direction: column;\n\n    ", "\n  "], ["\n    display: flex;\n    padding: ", ";\n    flex-direction: column;\n\n    ", "\n  "])), theme.UNIT(4), function (props) {
    return props.variant === "inverted" && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      background: ", ";\n    "], ["\n      background: ", ";\n    "])), theme.COLOR('dark'));
  })
});
var ValueStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    flex-wrap: nowrap;\n    flex-shrink: 0;\n  "], ["\n    flex-wrap: nowrap;\n    flex-shrink: 0;\n  "])))
});
var DescriptionStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    color: ", ";\n    font-size: ", ";\n    padding-top: ", ";\n\n    ", "\n  "], ["\n    color: ", ";\n    font-size: ", ";\n    padding-top: ", ";\n\n    ", "\n  "])), theme.COLOR('text'), theme.FONT_SIZE(13), theme.UNIT(3), function (props) {
    return props.variant === "inverted" && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), theme.COLOR('light'));
  })
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Value: styled(EntityValue)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles),
  Description: styled(ContentNode)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles)
};
export var EntitySelectOption = function EntitySelectOption(props) {
  var className = props.className,
      data = props.data,
      selectProps = props.selectProps,
      showDescription = props.showDescription;
  var entity = data.entity;
  var inputValue = selectProps.inputValue,
      variant = selectProps.variant;
  var description = coalesce(entity, ['description', 'openGraph.description']);
  return (
    /* @ts-ignore */
    React.createElement(Components.Option, __assign({}, props), React.createElement(My.Container, {
      variant: variant,
      className: cls.name(className)
    }, React.createElement(My.Value, {
      highlight: inputValue,
      entity: entity
    }), showDescription && description && React.createElement(My.Description, {
      variant: variant,
      entity: description
    })))
  );
};
export var EntitySelectOptionWithDescriptions = function EntitySelectOptionWithDescriptions(props) {
  return React.createElement(EntitySelectOption, __assign({}, props, {
    showDescription: true
  }));
};
export var EntitySelectOptionWithDescriptionsInverted = function EntitySelectOptionWithDescriptionsInverted(props) {
  return React.createElement(EntitySelectOption, __assign({}, props, {
    showDescription: true
  }));
};
EntitySelectOption.defaultProps = EntitySelectOptionDefaultProps;
EntitySelectOption.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;